import { render, staticRenderFns } from "./bridgeGame.vue?vue&type=template&id=1f2189d6&"
import script from "./bridgeGame.vue?vue&type=script&lang=js&"
export * from "./bridgeGame.vue?vue&type=script&lang=js&"
import style0 from "./bridgeGame.vue?vue&type=style&index=0&id=1f2189d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports